// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './style/iview/theme.less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueScrollTo from 'vue-scrollto'
import preview from 'vue-photo-preview'
import ElementUI from 'element-ui'
import 'vue-photo-preview/dist/skin.css'
import 'element-ui/lib/theme-chalk/index.css'

// Message插件
import MessagePlugin from 'gkui/message/index'

import Cookies from 'js-cookie'

import directives from './directives'
import filters from './filters'

Vue.use(VueAwesomeSwiper)
Vue.use(VueScrollTo)
Vue.use(preview)
Vue.use(ElementUI)
Vue.use(MessagePlugin)

/* eslint-disable */
// 决定是否打印日志
// if (!config.LOG) {
//   console.log = function () { return }
// }

// 定义全局指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

// 定义全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

const matchCommit = window.location.search.match(/commit_id=[a-z0-9]+/i)
const clearCommit = window.location.search.match(/commit_id=none/i)
if (matchCommit && !clearCommit) {
  Cookies.set('gk_commit_id', matchCommit[0].split('=')[1])
  // 测试
}

if (clearCommit) {
  Cookies.remove('gk_commit_id')
}
